import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MenuItemModel} from '../../../../models/menu/menu-item.model';
import {dropdown} from '../../../../animations';
import {Router} from '@angular/router';

@Component({
  selector: 'app-menu-item-top',
  templateUrl: './menu-item-top.component.html',
  styleUrls: ['./menu-item-top.component.scss'],
  animations: [dropdown],
})
export class MenuItemTopComponent implements OnInit {
  isSousmenuOpen = false;
  @Input() menuItem: MenuItemModel;
  @Output() menuClicked = new EventEmitter();

  constructor(private router: Router) {}

  ngOnInit() {}

  switchSousMenuOpen() {
    this.isSousmenuOpen = !this.isSousmenuOpen;
  }

  hideSousMenu() {
    this.isSousmenuOpen = false;
  }

  hasSousMenu() {
    return this.menuItem && this.menuItem.sousMenu.length > 0;
  }

  openOutsideURL(url: string) {}

  performMenuAction() {
    if (this.menuItem.routerLink != null) {
      this.router.navigateByUrl(this.menuItem.routerLink);
    }
    this.menuClicked.emit(true);
    return false;
  }
}
